import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import downArrow from "./down-arrow.svg";
import upArrow from "./up-arrow.svg";

import { ActionButton, Backdrop } from '../../components/Themed.js';
import {
  getVariations,
  getPricings,
  getCompletedVariations,
} from '../../data/service/ServiceActions.js';
import {
  getWorkingHours,
  getCustomHours,
  getEmployees,
} from '../../data/employee/EmployeeActions.js';
import { setClientVariation } from '../../data/client/ClientActions';
import {
  getVariationsWithAddons,
  getBookableVariations,
  calculatePricings,
} from '../../data/service/ServiceReducer.js';
import { getEstimatedEmployee } from '../../data/appointment/AppointmentServices.js';
import ModalMessage from '../../components/ModalMessage.js';

import ServicesVariation from './ServicesVariation.js';
import './Services.css';
import { t } from '../../locales';

class Services extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isNoServiceModalVisible: false,
      showingServiceCategory: {},
      variationsGroupedByDealId: {},
      disableCollapseExpandServiceCategory: false,
      showLoader: {}
    };

    this.variationSelect = this.variationSelect.bind(this);
    this.recalculatePrices = this.recalculatePrices.bind(this);
    this.continueClick = this.continueClick.bind(this);
    this.messageModalConfirmClick = this.messageModalConfirmClick.bind(this);
  }

  async componentDidMount() {
    const {
      getVariations,
      getWorkingHours,
      getCustomHours,
      getPricings,
      getEmployees,
    } = this.props;

    const { location } = this.props;

    await Promise.all([
      getVariations(),
      getWorkingHours(location.id),
      getCustomHours(location.id),
      getEmployees(location.id),
      getPricings(location.id),
    ]);

    this.setState({ isLoading: false });
    this.recalculatePrices();
    this.recalculateVariationsGroupedByDealId();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.clientVariations.length !== this.props.clientVariations.length
    ) {
      this.recalculatePrices();
    }

    const variationsChanged = prevProps.variations && this.props.variations && prevProps.variations.length !== this.props.variations.length;
    const completedVariationsChanged = prevProps.completedVariations && this.props.completedVariations && prevProps.completedVariations.length !== this.props.completedVariations.length;

    if (variationsChanged || completedVariationsChanged){
      this.recalculateVariationsGroupedByDealId();
    }
  }

  recalculatePrices() {
    const calculatedPrices = calculatePricings(
      this.props.allVariations,
      this.props.workingHours,
      this.props.customHours,
      this.props.employees,
      this.props.pricings,
      this.props.isNewClient,
      this.props.location.time_zone,
      this.props.clientVariations
    );

    this.setState({
      calculatedPrices,
    });
  }

  isSelected(variationId) {
    const { clientVariations } = this.props;
    const isSelected =
      clientVariations.filter(
        cv => cv.variationId === variationId
      ).length > 0;

    return isSelected;
  }

  recalculateVariationsGroupedByDealId() {
    const {
      variations,
      completedVariations,
      getCompletedVariations,
      company,
    } = this.props;

    const {
      calculatedPrices
    } = this.state

    const clientId = this.props.clientId || localStorage.getItem('clientId');

    const pricesByVariationId = calculatedPrices?.reduce((acc, price) => {
      acc[price.variationId] = price

      return acc
    }, {}) || {}

    const dealsToExpandBecauseVariationIsSelected = {};

    const initialOrFollowupServiceIds = variations?.filter(v => v.initial_consultation || v.followup)?.map(v => v.id) || [];

    let filteredVariations = [...variations?.filter(v => !!v?.variation_setting?.available_in_store)];

    if(initialOrFollowupServiceIds?.length) {
      getCompletedVariations(company?.id, clientId, initialOrFollowupServiceIds);
      const initialOrFollowupServiceAlreadyCompleted = initialOrFollowupServiceIds?.some(v => completedVariations.includes(v))
      const keyShouldBeFalse = initialOrFollowupServiceAlreadyCompleted ? 'initial_consultation' : 'followup';

      filteredVariations = variations?.filter(v => !v[keyShouldBeFalse]);
    }

    const variationsGroupedByDealId = filteredVariations.filter(v => {
      const servicePrice = pricesByVariationId[v.id]
      if (!servicePrice || servicePrice?.minPrice === null) {
        return false
      }
      return !v.hidden
    }).reduce((acc, variation) => {
      if (!acc[variation.deal_id]) {
        acc[variation.deal_id] = [variation];
      } else {
        acc[variation.deal_id].push(variation);
      }
      if (this.isSelected(variation.id)) {
        dealsToExpandBecauseVariationIsSelected[variation.deal_id] = true;
      }
      return acc
    }, {})

    if (Object.keys(variationsGroupedByDealId).length === 1) {
      // we only have 1 variation group
      this.setState({
        disableCollapseExpandServiceCategory: true
      });
    } else {
      this.setState({
        showingServiceCategory: dealsToExpandBecauseVariationIsSelected,
      });
    }

    this.setState({
      variationsGroupedByDealId
    })
  }

  async variationSelect(id, idParent, selected) {
    if (selected) {
      this.setState({showLoader: {
        ...this.state.showLoader,
        [id]: true
      }})
      const { location } = this.props;
      const employee = await getEstimatedEmployee(location.id, [id]);
      this.setState({showLoader: {
        ...this.state.showLoader,
        [id]: false
      }})
      if (!employee || !employee.estimation) {
        this.setState({ isNoServiceModalVisible: true });
        return;
      }
    }

    const { clientId, childId, setClientVariation } = this.props;
    setClientVariation(clientId, childId, id, idParent, selected);
  }

  messageModalConfirmClick() {
    this.setState({ isNoServiceModalVisible: false });
  }

  continueClick() {
    const {
      personNumber,
      personCount,
      history,
      employeeSelection,
      hasIntakeForms,
    } = this.props;
    const newPersonNumber = personNumber + 1;

    if (newPersonNumber < personCount) {
      history.push('/services/' + newPersonNumber);
    } else {
      if (hasIntakeForms) {
        history.push('/clientFormSecondary');
      } else {
        if (employeeSelection) {
          history.push('/staffSelection');
        } else {
          history.push('/summary');
        }
      }
    }
  }

  handleClickServiceCategory(dealId) {
    const { showingServiceCategory } = this.state

    showingServiceCategory[dealId] = !showingServiceCategory[dealId]

    this.setState({
      showingServiceCategory
    })
  }

  render() {
    const { calculatedPrices, isLoading, isNoServiceModalVisible, showingServiceCategory, variationsGroupedByDealId, disableCollapseExpandServiceCategory } = this.state;
    const { currencySymbol } = this.props;

    const selectedCount = this.props.clientVariations.length;
    let hasPrices = false;
    if (calculatedPrices) {
      calculatedPrices.forEach(cp => {
        if (cp.minPrice != null) hasPrices = true;
      });
    }

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        {
          isLoading && (
            <div className="spinner-container">
              <i className="fas fa-spinner fa-pulse services-spinner" />
            </div>
          )
        }
        {!isLoading && (
          <div className="scroll-container content-container">
            <div className="page-container">
              {hasPrices && (
                <div className="services-title">
                  {t('services.please_select_service_s')}
                  <br />
                  {t('services.for')} {this.props.personName}
                </div>
              )}
              {!hasPrices && (
                <div className="services-title">
                  {t(
                    'services.sorry_there_is_no_availability_for_this_service_today'
                  )}
                </div>
              )}
              <div className="content content-padding">
                {Object.keys(variationsGroupedByDealId).map((dealId) => {
                  return (
                   <React.Fragment key={dealId}>
                      {variationsGroupedByDealId[dealId].map((v, i) => (
                        <React.Fragment key={v.id}>
                          {
                            i === 0 &&
                              (disableCollapseExpandServiceCategory ?
                                <div
                                  className="service-category-deal-name">
                                  {v.service_name}
                                </div>
                                :
                                <div
                                  className="service-category-deal-name collapsible"
                                  onClick={() => this.handleClickServiceCategory(dealId)}>
                                  {v.service_name}
                                  { showingServiceCategory[dealId] && <img src={upArrow} alt="up arrow"/>}
                                  { !showingServiceCategory[dealId] && <img src={downArrow} alt="down arrow"/>}
                                </div>
                              )
                          }
                          {
                            (showingServiceCategory[dealId] || disableCollapseExpandServiceCategory) && (
                              <ServicesVariation
                                variation={v}
                                clientVariations={this.props.clientVariations}
                                showLoader={this.state.showLoader[v.id]}
                                onSelect={this.variationSelect}
                                prices={calculatedPrices}
                                currencySymbol={currencySymbol}
                                selectedChildId={this.props.childId}
                              />
                            )
                          }
                        </React.Fragment>
                      ))}
                   </React.Fragment>
                  )
                })}
              </div>
            </div>
          </div>
        )}
        {selectedCount > 0 && (
          <div className="services-controls">
            <div className="services-controls-summary">
              {selectedCount} Service{selectedCount > 1 ? 's' : ''}{' '}
              {t('services.selected')}
            </div>

            <ActionButton
              onClick={this.continueClick}
              className="services-controls-button"
              disabled={isNoServiceModalVisible}
            >
              {t('services.continue')}
            </ActionButton>
          </div>
        )}
        {isNoServiceModalVisible && (
          <ModalMessage
            text={t('services.sorry_there_is_no_availability_for_this_service_today')}
            onConfirmClick={this.messageModalConfirmClick}
          />
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const personNumber = parseInt(ownProps.match.params.personNumber, 10);
  const personCount =
    state.client.childrenSelectedForServices.length +
    (state.client.hasServicesForClient ? 1 : 0);
  const clientId = state.client.clientInformation.id;
  const childIndex = personNumber - (state.client.hasServicesForClient ? 1 : 0);
  const childId =
    state.client.hasServicesForClient && personNumber === 0
      ? null
      : state.client.childrenSelectedForServices[childIndex];

  const child = state.client.clientInformation.children.filter(
    c => c.id === childId
  )[0];
  const personName = child
    ? child.first_name
    : state.client.clientInformation.first_name;

  return {
    clientId: clientId,
    childId: childId,
    personNumber: personNumber,
    personCount: personCount,
    personName: personName,
    clientVariations: state.client.clientVariations.filter(
      cv => cv.clientId === clientId && cv.childId === childId
    ),

    location: state.app.location,
    company: state.app.businessInfo.company,
    allVariations: getBookableVariations(state.service.variations),
    variations: getVariationsWithAddons(state),
    completedVariations: state.service.completedVariations,
    workingHours: state.employee.workingHours,
    customHours: state.employee.customHours,
    employees: state.employee.employees,
    pricings: state.service.pricings,
    isNewClient: state.client.isNewClient,

    employeeSelection: state.app.businessInfo.company.user_can_select_employee,
    hasIntakeForms: state.app.businessInfo.company.data.has_intake_forms,
    currencySymbol: state.app.businessInfo.currencySymbol,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      getVariations,
      getCompletedVariations,
      setClientVariation,
      getWorkingHours,
      getCustomHours,
      getPricings,
      getEmployees,
    }
  )(Services)
);
